"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reaganCompatReporter = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var ReporterActionTypes = _interopRequireWildcard(require("./ReporterActionTypes"));

var _hubspot = _interopRequireDefault(require("hubspot"));

var _invariant = _interopRequireDefault(require("react-utils/invariant"));

var _performance = _interopRequireDefault(require("../vendor/performance"));

// TODO contentReady?
// TODO constants
// TODO make perform measures more accurate
// TODO state machine
var STATIC_DOMAIN_REGEX = /https:\/\/(static|local).hsappstatic.net\//; // If the duration of the request is <= 10ms mark the request as a cache hit.

var CACHE_DURATION_MS = 10;

var performanceMark = function performanceMark(name) {
  if (typeof _performance.default.mark === 'function') {
    _performance.default.mark(name);
  }
};

var performanceEntries = function performanceEntries() {
  if (typeof _performance.default.getEntries === 'function') {
    return _performance.default.getEntries() || [];
  }

  return [];
}; // mostly ported from reagan


var reaganCompatReporter = function reaganCompatReporter(newrelic) {
  if (!newrelic) {
    return function () {};
  }

  var lastAbandonedTimestamp = null;
  var abandonedTimes = [];

  var getHubHttpData = function getHubHttpData(finishedTimestamp) {
    if (typeof _hubspot.default.getAllHttpRequestStats === 'function' && typeof _performance.default.now === 'function') {
      var byStatus = function byStatus(status) {
        return function (_ref) {
          var state = _ref.state,
              started = _ref.started,
              finished = _ref.finished;
          return started < finishedTimestamp && (status === 'pending' ? state === 'pending' || finished > finishedTimestamp : state === status && finished <= finishedTimestamp);
        };
      };

      var MAX_URLS = 10;

      var toUrls = function toUrls(arr) {
        return arr.slice(0, MAX_URLS).map(function (r) {
          return r.url;
        }).join(',');
      };

      var requests = _hubspot.default.getAllHttpRequestStats();

      var succeededRequests = requests.filter(byStatus('succeeded'));
      var failedRequests = requests.filter(byStatus('failed'));
      var abortedRequests = requests.filter(byStatus('aborted'));
      var pendingRequests = requests.filter(byStatus('pending'));
      var timedOutRequests = requests.filter(byStatus('timedOut'));
      var failedRequestsMinus404AndRetries = failedRequests.filter(function (r) {
        return r.status !== 404 && !r.willBeRetried;
      });
      var notFoundRequests = failedRequests.filter(function (r) {
        return r.status === 404;
      });
      return {
        numSucceededRequests: succeededRequests.length,
        numAbortedRequests: abortedRequests.length,
        numPendingRequests: pendingRequests.length,
        numNotFound: notFoundRequests.length,
        numTimedoutRequests: timedOutRequests.length,
        numFailedRequestsMinus404AndRetries: failedRequestsMinus404AndRetries.length,
        numRetriedFailures: failedRequests.filter(function (r) {
          return !!r.willBeRetried;
        }).length,
        failedRequestUrls: toUrls(failedRequestsMinus404AndRetries),
        timedOutRequestUrls: toUrls(timedOutRequests),
        pendingRequestUrls: toUrls(pendingRequests),
        notFoundUrls: toUrls(notFoundRequests)
      };
    }

    return null;
  };

  var getCacheStatusData = function getCacheStatusData() {
    var cacheStatusData = {};
    performanceEntries().forEach(function (timing) {
      if (timing.name.endsWith('.js')) {
        var fileName = timing.name.replace(STATIC_DOMAIN_REGEX, '');
        cacheStatusData[fileName] = {
          cached: timing.duration <= CACHE_DURATION_MS,
          duration: timing.duration
        };
      }
    });
    return cacheStatusData;
  };

  var getNumFailedImages = function getNumFailedImages() {
    return (0, _toConsumableArray2.default)(document.getElementsByTagName('img')).reduce(function (total, ele) {
      return ele.src && ele.naturalHeight === 0 && ele.naturalWidth === 0 ? total + 1 : total;
    }, 0);
  };

  var finish = function finish(attrs, checks) {
    var finishedTimestamp = attrs.finishedTimestamp;
    var hubHttpData = getHubHttpData(finishedTimestamp);
    var avgDurationBeforePreviousReaganAborts = abandonedTimes.reduce(function (acc, duration) {
      return acc + duration / abandonedTimes.length;
    }, 0);
    var cacheData = getCacheStatusData();
    var reaganTiming = {};
    Object.keys(checks).forEach(function (marker) {
      if (checks[marker].mounted) {
        reaganTiming["marker_timing_" + marker] = checks[marker].timestamp;
      }
    });
    newrelic.setCustomAttribute('numReaganChecksStarted', abandonedTimes.length + 1);
    newrelic.setCustomAttribute('numPreviousReaganChecksAborted', abandonedTimes.length);
    newrelic.setCustomAttribute('avgDurationBeforePreviousReaganAborts', avgDurationBeforePreviousReaganAborts);
    newrelic.setCustomAttribute('numPreviousReaganChecksFailed', 0);
    newrelic.setCustomAttribute('numPreviousReaganChecksSuccessful', 0);
    newrelic.setCustomAttribute('supportsUserTiming', typeof _performance.default.mark === 'function');
    newrelic.setCustomAttribute('supportsPerformanceTimeline', typeof _performance.default.getEntriesByType === 'function');
    newrelic.setCustomAttribute('supportsHighResolutionTime', typeof _performance.default.now === 'function');
    newrelic.addPageAction('reaganFinished', (0, _extends2.default)({}, attrs, hubHttpData, {
      numFailedImages: getNumFailedImages(),
      cacheData: JSON.stringify(cacheData)
    }, reaganTiming));
  };

  var finished = false;
  return function (action) {
    if (finished) {
      return;
    }

    var _action$payload = action.payload,
        _action$payload$entry = _action$payload.entry,
        timestamp = _action$payload$entry.timestamp,
        checks = _action$payload$entry.checks,
        pathname = _action$payload$entry.pathname,
        expiredTimestamp = _action$payload$entry.expiredTimestamp,
        routeSpec = _action$payload.routeSpec;

    switch (action.type) {
      case ReporterActionTypes.ROUTE_SUCCEEDED:
      case ReporterActionTypes.ROUTE_FAILED:
      case ReporterActionTypes.ROUTE_TIMEOUT_EXPIRED:
      case ReporterActionTypes.ROUTE_UNEXPECTED:
        {
          finished = true;
          break;
        }

      default:
    }

    switch (action.type) {
      case ReporterActionTypes.ROUTE_STARTED:
        {
          if (lastAbandonedTimestamp) {
            abandonedTimes.push(timestamp - lastAbandonedTimestamp);
          }

          break;
        }

      case ReporterActionTypes.ROUTE_UNEXPECTED:
        {
          newrelic.addPageAction('react-rhumb-event', {
            eventName: 'UnexpectedRouteVisited',
            pathname: pathname
          });
          break;
        }

      case ReporterActionTypes.ROUTE_ABANDONED:
        {
          lastAbandonedTimestamp = timestamp;
          break;
        }

      case ReporterActionTypes.ROUTE_SUCCEEDED:
        {
          var success = routeSpec.success,
              route = routeSpec.route;
          var scenario = action.payload.extra.scenario;

          if (process.env.NODE_ENV !== 'production') {
            (0, _invariant.default)(success[scenario].length > 0, 'routeSpec for %s must have at least one `success` marker for %s', route, scenario);
          }

          var maxTimestamp = Math.max.apply(Math, (0, _toConsumableArray2.default)(success[scenario].map(function (m) {
            return checks[m].timestamp;
          })));
          var duration = Math.max(0, maxTimestamp - timestamp);
          finish({
            status: 'success',
            timeToAllSuccess: (timestamp + duration) / 1000,
            scenario: scenario,
            finishedTimestamp: maxTimestamp,
            route: route
          }, checks);
          performanceMark("mark_all_success");
          break;
        }

      case ReporterActionTypes.ROUTE_FAILED:
        {
          var _route = routeSpec.route,
              error = routeSpec.error;
          var markers = error.filter(function (marker) {
            return checks[marker] && checks[marker].mounted;
          });

          if (process.env.NODE_ENV !== 'production') {
            (0, _invariant.default)(markers.length > 0, 'routeSpec for %s must have at least one `failure` marker for', _route);
          } // TODO how to report multiple failed markers without separate page actions


          var _markers = (0, _slicedToArray2.default)(markers, 1),
              failedMarker = _markers[0];

          var finishedTimestamp = checks[failedMarker].timestamp;
          finish({
            status: 'failure',
            failureType: 'errorSelector',
            selector: failedMarker,
            finishedTimestamp: finishedTimestamp,
            route: _route
          }, checks);
          performanceMark("mark_all_failure");
          break;
        }

      case ReporterActionTypes.ROUTE_TIMEOUT_EXPIRED:
        {
          var _route2 = routeSpec.route;
          finish({
            status: 'failure',
            failureType: 'watchdogExpired',
            finishedTimestamp: expiredTimestamp,
            route: _route2
          }, checks);
          performanceMark("mark_all_failure_watchdog_expired");
          break;
        }

      default:
    }
  };
};

exports.reaganCompatReporter = reaganCompatReporter;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/react-rhumb/static-1.5051/js/internal/reaganCompatReporter.js
// module id = 555
// module chunks = 5 6